// src/products/well3d/useWell3DStore.js
//
// State shared between Well3DSurface (writer) and Well3DPanel (reader).
// Mirrors the pattern of useWellFinderStore / useWellSelectionStore — a
// thin Zustand store so both components can subscribe to the same state
// without the parent re-rendering them.

import { create } from 'zustand';

export const useWell3DStore = create((set) => ({
  // Wells with full directional data (rendered as 3D wellbores)
  wells: [],
  // Wells from /wells/rrc-near (surface points only — rendered as pads)
  surfaceWells: [],
  loading: false,
  loadMsg: '',
  error: null,
  // API of the well the user clicked on the globe
  selected: null,
  // Live camera state from the Cesium viewer's postRender event
  camera: { h: 0, pitch: 0, alpha: 1 },

  // Surface writes
  setWells:        (wells)        => set({ wells }),
  setSurfaceWells: (surfaceWells) => set({ surfaceWells }),
  setLoading:      (loading)      => set({ loading }),
  setLoadMsg:      (loadMsg)      => set({ loadMsg }),
  setError:        (error)        => set({ error }),
  setSelected:     (selected)     => set({ selected }),
  setCamera:       (camera)       => set({ camera }),
}));
